module.exports = __webpack_public_path__ + "1ec06eed11bbcb1ee510b8f3522adea8.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/fonts/roboto-slab-regular.ttf
// module id = ./src/components/main/fonts/roboto-slab-regular.ttf
// module chunks = index